/** Overview screen: business cards, projects, business settings form. */
export const businesses = {
  'overview.newBusiness': 'Новий бізнес',
  'overview.projects.none': 'поки немає',
  'overview.projects.add': '+ проєкт',
  'overview.projects.name': 'Назва проєкту',
  'overview.tasksBtn': 'Задачі',
  'overview.settingsBtn': 'Налаштування',
  'overview.settings.title': 'Налаштування бізнесу · {name}',
  'overview.settings.newTitle': 'Новий бізнес',
  'overview.settings.name': 'Назва',
  'overview.settings.slug': 'Slug',
  'overview.settings.taskPrefix': 'Префікс задач',
  'overview.settings.language': 'Мова',
  'overview.settings.currency': 'Валюта',
  'overview.settings.timezone': 'Часовий пояс',
  'overview.settings.members': 'Учасники',
  'overview.settings.pause': 'Призупинити бізнес',
  'overview.settings.activate': 'Активувати бізнес',
  'overview.status.active': 'активний',
  'overview.status.paused': 'призупинений',
  'overview.status.archived': 'архівний',
} as const;
